import { useContext } from 'react'
import { ObjectContext } from '../contexts/objectContext/ObjectContext'
import { trpc } from '../modules/trpc'

/**
 * Hook for fetching contract information based on the current contract ID from the ObjectContext.
 * @returns An object containing the contract data and loading state.
 */
export const useContract = () => {
	const { synerallContractId } = useContext(ObjectContext)

	const { data: contractData, isFetching: isContractLoading } =
		trpc.synerall.contractInformation.useQuery(
			{
				contractId: synerallContractId!,
			},
			{
				enabled: !!synerallContractId, // Only fetch if contract ID exists
			}
		)
	return { contractData, isContractLoading }
}
